export default __webpack_public_path__ + "d505504f04944b2e7c02b984f695dda9.png";